export default __webpack_public_path__ + "static/7_17-a1530fcd427bf73a5d0064cfae10bb4f.png";